/* eslint-disable no-console */
// Tiny dev-only logger. In production builds (NODE_ENV === 'production'),
// CRA replaces process.env.NODE_ENV at build time and the dead branch is
// eliminated by terser, so these calls vanish from the production bundle.

const IS_DEV = process.env.NODE_ENV !== 'production';

export const devWarn = (...args) => {
  if (IS_DEV) console.warn(...args);
};

export const devError = (...args) => {
  if (IS_DEV) console.error(...args);
};
